// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2sosq","options":"AnswerScale_options__1lB_V","selected":"AnswerScale_selected__14p2W"};